import IconToolTip from "@/Components/Icon/IconToolTip";
import Select from "@/Components/Select/Select";
import { canSoundAtom } from "@/shared/atoms";
import usePreferredSoundEngine from "@/shared/atoms/usePreferredEngineAtom";
import useCommon from "@/shared/hooks/useCommon";
import useIsMobileHook from "@/shared/hooks/useIsMobileHook";
import { SoundEngineType } from "@/shared/utils/enum";
import { useAtom } from "jotai";

const options = [
  { label: "use-sound", value: SoundEngineType.USE_SOUND },
  { label: "howler", value: SoundEngineType.HOWLER },
];

const LiveSound = () => {
  const t = useCommon();
  const isMobile = useIsMobileHook();
  const [canSound, setCanSound] = useAtom(canSoundAtom);
  const [engine, setEngine] = usePreferredSoundEngine();

  return (
    <div
      className={isMobile ? "ml-auto flex" : "ml-8 flex"}
      data-tour="live-orders.sound"
    >
      <div onClick={() => setCanSound(!canSound)}>
        <IconToolTip
          text={canSound ? t("orders_live.mute") : t("orders_live.unmute")}
          variants={canSound ? "soundup" : "soundmute"}
          className="fill-text"
        />
      </div>
      {!isMobile && (
        <div className="w-[15rem]">
          <Select
            options={options}
            onChange={(val) => setEngine(val.value)}
            value={options.find(({ value }) => value === engine)}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.getElementById("root")}
          />
        </div>
      )}
    </div>
  );
};

export default LiveSound;
